import { useMutation } from '@tanstack/react-query';
import patchUserInfo from '../../../../service/Admin/User/Patch/patchUserInfo';
import { ALERT_MODAL_STATUS } from '../../../../constant/Common/Modal/Alert/status';
import useControlToast from '../../../Common/Toast/useControlToast';
import { SUCCESS_UPDATE } from '../../../../constant/Common/Message/success';
import updateButtonDisabled from '../../../../util/Common/Controller/Handler/updateButtonDisabled';
import updateGridData from '../../../../util/Common/Datagrid/Handler/updateGridData';

const usePatchUserInfo = ({
  gridRef,
  setIsOpenErrorModal,
  setAlertInfo,
  setIsOpenSideModal,
  setUserID,
}) => {
  const { addToast } = useControlToast();

  const mutate = useMutation({
    mutationFn: patchUserInfo,
    onSettled: (data, error, variables) => {
      if (variables?.buttonRef)
        updateButtonDisabled({ ref: variables.buttonRef, disabled: false });
    },
    onSuccess: (data, variables) => {
      updateGridData({
        gridRef,
        newData: { id: variables?.id, ...variables?.patchData, ...data?.data },
        key: 'id',
        isUpdate: true,
      });
      addToast({ message: SUCCESS_UPDATE });
      setIsOpenSideModal(false);
      setUserID(null);
    },
    onError: error => {
      setIsOpenErrorModal(true);
      setAlertInfo({
        status: ALERT_MODAL_STATUS?.ERROR,
        message: error?.message,
      });
    },
  });
  return { ...mutate };
};

export default usePatchUserInfo;
